import Loadable from 'react-loadable';

export const CreateGoalModal = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "CreateGoalModal" */ './TownsquareGoalCreateModal'),
  loading: () => null,
});
